import { loadTossPayments } from '@tosspayments/tosspayments-sdk';
import { PaymentMethod, TossPaymentsMethod } from '../../enum';
import { TossPreparePaymentResponseDto } from '../../constants/types/purchase-type';

/**
 * 토스페이먼츠 결제창 호출 함수
 * @description Promise 방식은 모바일 환경에서 사용할 수 없으므로, Redirect방식으로 결제창을 띄움
 */
async function TossPayments(paymentConfig: TossPreparePaymentResponseDto) {
  /**
   * 토스페이먼츠 SDK 초기화
   * @see https://docs.tosspayments.com/sdk/v2/js#토스페이먼츠-초기화
   */
  const tossPayments = await loadTossPayments(paymentConfig.clientKey);

  /**
   * 토스페이먼츠 결제창 초기화
   * @see https://docs.tosspayments.com/sdk/v2/js#결제창-초기화
   */
  const payment = tossPayments.payment({
    customerKey: paymentConfig.customerKey,
  });

  /**
   * 로컬 테스트 시 successUrl/failUrl을 localhost로 오버라이드
   */
  const successUrl =
    process.env.NODE_ENV === 'development'
      ? `${window.location.origin}/commerce/purchase/success`
      : paymentConfig.successUrl;
  const failUrl =
    process.env.NODE_ENV === 'development'
      ? `${window.location.origin}/commerce/purchase/fail`
      : paymentConfig.failUrl;

  /**
   * 토스페이먼츠 결제창 띄우기
   * @see https://docs.tosspayments.com/sdk/v2/js#결제창-띄우기
   * @description Redirect 방식 : [사용중] 파라미터로 설정한 successUrl/failUrl로 결제 요청의 결과를 확인할 수 있음
   * @description Promise 방식 : [미사용] Promise로 돌아오는 객체로 결과를 확인할 수 있지만, 모바일 환경에서 사용 불가
   */
  const baseRequest = {
    amount: {
      value: paymentConfig.amount,
      currency: 'KRW',
    },
    orderId: paymentConfig.orderId,
    orderName: paymentConfig.orderName,
    successUrl,
    failUrl,
    customerEmail: paymentConfig.customerInfo?.email,
    customerName: paymentConfig.customerInfo?.name,
    customerMobilePhone: paymentConfig.customerInfo?.mobilePhone,
  };

  switch (paymentConfig.metadata.paymentMethod) {
    case PaymentMethod.CREDIT_CARD:
      await payment.requestPayment({
        ...baseRequest,
        method: TossPaymentsMethod.CREDIT_CARD,
      });
      break;
    case PaymentMethod.BANK_TRANSFER:
      await payment.requestPayment({
        ...baseRequest,
        method: TossPaymentsMethod.BANK_TRANSFER,
      });
      break;
    case PaymentMethod.DEPOSIT:
      await payment.requestPayment({
        ...baseRequest,
        method: TossPaymentsMethod.DEPOSIT,
      });
      break;
    default:
      throw new Error(
        `지원하지 않는 결제 수단입니다: ${paymentConfig.metadata.paymentMethod}`,
      );
  }
}

export default TossPayments;
